export { default } from './BorrowingBatchActionsOverlay';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingBatchActionsOverlay/index.js